import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TokenPair } from './token-pair.model';

@Injectable({ providedIn: 'root' })
export class OtpAuthService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/api/v1/auth`;

  requestCode(email: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/otp/request`, { email });
  }

  // withCredentials lets the browser store and send the httpOnly refresh cookie across origins.
  verifyCode(email: string, code: string): Observable<TokenPair> {
    return this.http.post<TokenPair>(`${this.baseUrl}/otp/verify`, { email, code }, { withCredentials: true });
  }

  refresh(): Observable<TokenPair> {
    return this.http.post<TokenPair>(`${this.baseUrl}/refresh`, {}, { withCredentials: true });
  }

  logout(): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/logout`, null, { withCredentials: true });
  }
}
